<script>
    export default {
        props: [
            'rows'
        ],
        render: function (createElement) {
            return createElement(
                'tbody',
                _.flatMap(this.rows, row => this.renderRow(row, 1, createElement))
            )
        },
        methods: {
            renderRow(row, level, createElement) {
                let result = [];
                let has_children = row.rows && row.rows.length;
                result.push(
                    createElement('tr', {
                        on: {
                            'click': () => { row.open = !row.open }
                        },
                        class: ['period-budget'],
                        style: {
                            'cursor': has_children ? 'pointer' : 'arrow'
                        }
                    }, [
                        createElement('td', { style: { 'padding-left': level * 30 + 'px' }},
                            [
                                row.name,
                                has_children ? createElement('span', { class: ['glyph-close', 'glyphicon', row.open ? 'glyphicon-collapse-down' : 'glyphicon-collapse-up', 'is-aligned-right']}) : null
                            ]
                        ),
                        createElement('td', { attrs: { colspan: 5 }}),
                        createElement('td', numeral(row.value).format('$ 0,0.00')),
                        createElement('td', { attrs: { colspan: 6 }}),
                    ])
                );
                if (row.open && has_children) {
                    let flatMap = _.flatMap(row.rows, (r) => this.renderRow(r, level + 1, createElement));
                    result = _.concat(result, flatMap);
                }
                return result;
            }
        }
    }
</script>
